<template>
    <div class="login-container" :style="{ backgroundColor: theme.primaryColor, color: theme.textColor }">
      <div class="login-box">
        <div class="logoContainer">
        <img class="img3" src="/logos/HTML-Creator.png" alt="Logo" /><img class="img4" src="/CartagoCreatorBlau.png" alt="Logo" />
        </div>
        <div class="mainLogin">
          <div class="login-header">
            <h2>Cartago® Live HTML Creator</h2>
          </div>
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label :style="{ backgroundColor: theme.primaryColor, color: theme.textColor }" for="username">{{ $t('Login.User') }}</label>
              <input
                id="username"
                v-model="username"
                type="text"
                placeholder=" "
                required
              />
            </div>
            <div class="form-group">
              <label :style="{ backgroundColor: theme.primaryColor, color: theme.textColor }" for="password">{{ $t('Login.Password') }}</label>
              <input
                id="password"
                v-model="password"
                type="password"
                placeholder=" "
                required
              />
            </div>
            <button type="submit" class="submit-button" :style="{ backgroundColor: theme.textColor, color: theme.name == 'Legacy'? theme.secondaryColor : theme.primaryColor}">{{ $t('Login.Login') }}</button>
          </form>
        </div>
        <div class="loginFooter">
          <div class="version">Version 0.7.1</div>
          <div class="login-icons">
              <div class="dropdown">
                <div v-if="showLang" class="language-popup">
                  <div class="dropdown-item" @click="changeLanguage('en')">EN</div>
                  <div class="dropdown-item" @click="changeLanguage('de')">DE</div>
                  <div class="dropdown-item" @click="changeLanguage('es')">ES</div>
                  <div class="dropdown-item" @click="changeLanguage('ro')">RO</div>
                  <div class="dropdown-item" @click="changeLanguage('fr')">FR</div>
                </div>
              </div>
              <button @click="showLang = !showLang" class="icon-button">
              <span class="material-symbols-outlined icon" >language</span>
              <div class="tooltip">{{ $t('Login.Language') }}</div>
            </button>
            <!-- <button @click="openThemeSelector" class="icon-button">
              <span class="material-symbols-outlined icon">palette</span>
              <div class="tooltip">Design ändern</div>
            </button> -->
          </div>
        </div>
      </div>
  
      <div class="img-container">
        <img class="img" src="/GebäudezeichnungFinal.png" alt="Gebäudezeichnung" />
      </div>

    </div>
  </template>
  <script>
  
  import {mapActions, mapState} from 'vuex';
  
  export default {
    data() {
      return {
        username: '',
        password: '',
        selectedVersion: '',
        versions: ['1.0', '2.0', '3.0'],
        showLang: false
      };
    },
    computed: {
      ...mapState(['theme']),
    },
    methods: {
      ...mapActions(['setLocale', 'setUser']),
      changeLanguage(lang) {
          this.setLocale(lang);  // Vuex-Aktion aufrufen, um die Sprache zu setzen
          this.$i18n.locale = lang; // Sprache im i18n-Plugin setzen
          this.showLang = false; // Dropdown schließen
    },
    async handleSubmit() {
        try {
            const response = await fetch('https://html-creator.demo.cartago.com/api/auth/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username: this.username, password: this.password })
            });
            const data = await response.json();
            if (data.accessToken) {
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);
            window.location.reload();  // Neuladen der App, um Auth-Status zu aktualisieren
            this.setUser(this.username)
            } else {
            alert('Login fehlgeschlagen: ' + data.error);
            }
        } catch (error) {
            console.error('Fehler beim Login:', error);
        }
}

    },
  };
  </script>
  <style scoped>
  /* Container für die Login-Maske */
  .login-container {
    display: flex;
    width: 100%;
    min-height: 100vh;
    font-family: 'Montserrat', sans-serif;
  }
  
  /* Linke Seite: Login-Box */
  .login-box {
    flex: 1;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1)
  }
  
  .img2 {
    max-width: 200px;
  }
  
  .img3 {
    max-width: 70px;
  }

  .img4{
    max-width: 90px;
    display: block;
  }
  
  .mainLogin {
    margin: auto;
    width: 70%;
  }
  
  /* Modernisierte Formularfelder */
  .form-group {
    position: relative;
    margin-bottom: 25px;
  }
  
  .form-group input,
  .form-group select {
    width: 100%;
    height: 28px;
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    background: transparent;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }
  
  .form-group input{
    width: 93%
  }
  
  .form-group select{
    height: 51px;
  }
  
  .form-group input:focus,
  .form-group select:focus {
    border-color: #15779b;
    box-shadow: 0 0 5px rgba(21, 119, 155, 0.5);
  }
  
  .form-group label {
    position: absolute;
    top: -10px;
    left: 15px;
    font-size: 14px;
    color: #15779b;
    background: #fff;
    padding: 0 5px;
    transition: color 0.3s ease, font-size 0.3s ease;
    pointer-events: none;
  }
  
  .form-group input:not(:placeholder-shown) + label,
  .form-group select:not(:placeholder-shown) + label {
    color: #15779b;
    font-size: 14px;
  }
  
  /* Modernisierte Schaltfläche */
  .submit-button {
    width: 100%;
    padding: 12px;
    background-color: #15779b;
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 18px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.1s ease;
    height: 50px;
  }
  
  .submit-button:hover {
    background-color: #0e4b5f;
  }
  
  .submit-button:active {
    transform: scale(0.98);
  }
  
  /* Rechte Seite: Bild */
  .img-container {
    flex: 2;
    height: 100vh;
    overflow: hidden;
  }
  
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .login-icons {
    display: flex;
    gap: 15px;
    position: relative;
  }
  
  .icon-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
    color: #666;
    transition: color 0.3s ease, transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .icon-button:hover {
    color: #15779b;
    transform: scale(1.1); /* Vergrößert das Icon leicht bei Hover */
  }
  
  .icon-button:active {
    transform: scale(0.95); /* Drückt das Icon leicht bei Klick */
  }
  
  .login-header{
    margin-bottom: 60px;
  }
  
  .loginFooter{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  
  .icon {
    font-size:26px;
  }
  
  /* Tooltip */
  .tooltip {
    position: absolute;
    bottom: 130%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 4px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    white-space: nowrap;
  }
  
  .icon-button:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }

  .language-popup {
  position: absolute;
  bottom: 30px;
  left: 7px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  color: black;
  font-weight: bold;
}

.dropdown-item:hover {
  background-color: #f1f1f1;
}
  
  </style> 
  